import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export type StepDotState = "current" | "completed" | "pending";

interface StepDotProps {
  label: string;
  state?: StepDotState;
  className?: string;
}

const STATE_STYLES: Record<StepDotState, string> = {
  current: "bg-primary text-white border-primary",
  completed: "bg-success text-white border-success",
  pending: "bg-transparent text-foreground-secondary border-border",
};

export function StepDot({ label, state = "pending", className }: StepDotProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center w-8 h-8 rounded-full border font-sans text-[10px] tracking-widest font-bold transition-colors",
        STATE_STYLES[state],
        className,
      )}
      aria-current={state === "current" ? "step" : undefined}
    >
      {state === "completed" ? (
        <Check className="w-4 h-4" strokeWidth={2.4} />
      ) : (
        label
      )}
    </span>
  );
}

interface StepDotOnHeroProps {
  label: string;
  active: boolean;
  className?: string;
}

export function StepDotOnHero({
  label,
  active,
  className,
}: StepDotOnHeroProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center w-7 h-7 rounded-full border font-sans text-[10px] tracking-widest font-bold transition-colors",
        active
          ? "bg-white text-primary border-white"
          : "bg-transparent text-white/60 border-white/30",
        className,
      )}
    >
      {label}
    </span>
  );
}
